module.exports = __webpack_public_path__ + "img/clients-holidayinn.b63e058f.png";